import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Overview from '../Overview';
import Mls from '../Overview/Mls';
import Sale from '../Sale';
import Search from '../Search';
import SaleWizard from '../SaleWizard';
import Whitelisting from '../Whitelisting';

// nginx rewrites every unmatched path to index.html, so any file-looking
// request under /dashboard (silent-renew.html, favicon.ico, a stray source map)
// used to boot the SPA and be handed to :sale as if it were a sale id. Sale ids
// never contain a dot, so excluding it keeps those requests out of the router.
const SALE_ID = '[^/.]+';

const Routes = () => {
  return (
    <Switch>
      <Route path="/dashboard/mls" component={Mls} />
      <Route path="/dashboard/search" component={Search} />
      <Route
        path={`/dashboard/:sale(${SALE_ID})/whitelisting/:user/:action`}
        component={Whitelisting}
      />
      <Route
        path={`/dashboard/:sale(${SALE_ID})/wizard`}
        component={SaleWizard}
      />
      <Route path={`/dashboard/:sale(${SALE_ID})`} component={Sale} />
      <Route component={Overview} />
    </Switch>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/app/containers/Dashboard/Routes.jsx